// coloca os valores do array em ordem decrescente
function getSortedArray(arrays) {
  return [].concat(...arrays).sort((a, b) => b.valorBem - a.valorBem);
}

// retorna um array com os multiplos de cada valor do grupo
function getMultiples(referenceValue, credits) {
  return credits.map(value => Math.floor(referenceValue / value.valorBem));
}

// encontra o valor mais próximo do valor procurado
export function findIdealCredit(valorProcurado, credits) {
  getSortedArray(credits);
  let multNumbers = getMultiples(valorProcurado, credits);

  let idealCredit = credits[0].valorBem;
  let minimalDif = Math.abs(valorProcurado - idealCredit * multNumbers[0]);

  for (let i = 1; i < credits.length; i++) {
    let dif = Math.abs(valorProcurado - credits[i].valorBem * multNumbers[i]);

    if (dif < minimalDif) {
      idealCredit = credits[i];
      minimalDif = dif;
    }
  }

  return {
    idealCredit: idealCredit, 
    multNumber: multNumbers[credits.indexOf(idealCredit)]
  };
}